import Mustache from "mustache";
import SwiperCarousel from "../swiper/index";

let map = null;
let centerMapBounds = {};
let bounds = null;
function initMarketMap() {
  // New Market Map
  let $marketMap = $(".js-market-new-map");

  if ($marketMap.length > 0) {
    marketNewMap($marketMap);
    hoverPin();
    handleMobileMap();
    eventCloseMap();
  }
}

function marketNewMap(container) {
  if (!window.google) {
    $.getScript(
      "//maps.googleapis.com/maps/api/js?&key=AIzaSyC5vdkfee3wDMr2NGRwMEJMaKCWZimFEkY"
    )
      .done(function () {
        createMarketMap(container);
      })
      .fail(function () {
        container.text("Could not load Google Maps!");
      });
  } else {
    createMarketMap(container);
  }
}

function createMarketMap(el) {
  var mapOptions = {
    zoom: 8,
    minZoom: 1,
    maxZoom: 20,
    backgroundColor: "transparent",
    streetViewControl: false,
    mapTypeControl: false,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    scrollwheel: false,
    disableDefaultUI: true,
    gestureHandling: "greedy",
    zoomControl: false,
    rotateControl: false,
    scaleControl: false,
    fullscreenControl: false,
    clickableIcons: false,
    clickableLabels: false,
    markers: [],
  };
  map = new google.maps.Map(el[0], mapOptions);

  //Custom Zoom Controls
  let ZoomControlsDiv = document.createElement("div");
  createZoomControls(ZoomControlsDiv, map);
  ZoomControlsDiv.index = 1;
  map.controls[google.maps.ControlPosition.LEFT_TOP].push(ZoomControlsDiv);

  let infoWindows = [];
  if (window.marketLocations) {
    bounds = new google.maps.LatLngBounds();
    centerMapBounds = bounds;
    window.marketLocations.forEach((location, i) => {
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(location.latitude, location.longitude),
        icon: {
          path:
            "m 123.0503,640.76516 c 2.31198,2.33425 3.70486,5.42807 3.92193,8.71122 0.11879,1.79866 -0.1444,3.60211 -0.77216,5.29115 -0.6116,1.67937 -1.60546,3.26671 -2.95864,4.70836 l -8.68481,9.27868 c -0.14238,0.15823 -0.3456,0.24758 -0.55809,0.24543 -0.21176,-10e-4 -0.41364,-0.0901 -0.55809,-0.24543 l -8.68481,-9.27868 c -1.35318,-1.44165 -2.34704,-3.02899 -2.95864,-4.70836 -0.62038,-1.69093 -0.88334,-3.49281 -0.77216,-5.29115 0.21552,-3.28354 1.60864,-6.37788 3.92193,-8.71122 2.39931,-2.41058 5.65584,-3.76516 9.05177,-3.76516 3.39593,0 6.65247,1.35458 9.05177,3.76516 z M 114,646 c -2.20513,0 -4,1.79449 -4,4 0,2.20551 1.79487,4 4,4 2.20513,0 4,-1.79449 4,-4 0,-2.20551 -1.79487,-4 -4,-4 z",
          strokeWeight: 0,
          fillColor: "#084c4f",
          fillOpacity: 1,
          rotation: 0,
          scale: 1,
          anchor: new google.maps.Point(114, 665),
        },
        flat: true,
        url: location.url,
        map: map,
        zIndex: 1,
        markerId: i + 1,
        isActive: false,
      });
      bounds.extend(marker.position);
      map.markers.push(marker);
      location.tag_text = location.show_promo_banner
        ? location.tag_override
        : location.text_status;
      location.tag_color = location.show_promo_banner
        ? location.color_promo_banner
        : "var(--tertiary-color)";

      var contentString = [
        '<div class="marker-market-wrapper">',
        '{{#show_tag}}<span class="btn-squared-tag btn-squared-tag-xs label-tag" style="background:{{tag_color}}; color:{{color_text_promo_banner}};">{{tag_text}}</span>{{/show_tag}}',
        '<div class="marker-market-carousel-wrapper">',
        "{{location}}",
        "{{#carousel_first_item}}",
        '<a class="link-to-all gtm-view-details" href="{{permalink}}" data-location="{{location_title}}" aria-label="Go to {{location_title}}"></a>',
        '<img class="stretch-image" src="{{carousel_first_item}}" />',
        "{{/carousel_first_item}}",
        "</div>",
        '<div class="market-location-content">',
        '<a class="link-to-all gtm-view-details" href="{{permalink}}" data-location="{{location_title}}" aria-label="Go to {{location_title}}"></a>',
        '<div class="content-wrapper">',
        '<h3 class="marker-title">{{location_title}}</h3>',
        "{{#inter_address}}",
        '<div class="address inter-address">{{{inter_address}}}, {{country}}</div>',
        "{{/inter_address}}",
        "{{^inter_address}}",
        '<div class="address">{{address}}</div>',
        '<div class="address">{{city}}, {{abbr}} {{zip}}</div>',
        "{{/inter_address}}",
        "{{#show_phone}}",
        '<div class="phone-wrapper">',
        '<a class="phone" href="tel:{{phone}}">{{phone}}</a>',
        "</div>",
        "{{/show_phone}}",
        "</div>",
        '<div class="market-location-action">',
        "{{^office_price}}",
        '<div class="price-content"></div>',
        "{{/office_price}}",
        '<div class="see-location"><a class="btn-link tertiary-text-color gtm-view-details" data-location="{{location_title}}" href="{{permalink}}">Learn More</a></div>',
        "</div>",
      ].join("\n");

      var htmlMarker = Mustache.render(contentString, location);
      var infoWindow = new google.maps.InfoWindow();
      infoWindow.setContent(htmlMarker);
      infoWindows.push(infoWindow);

      infoWindow.addListener("domready", function () {
        SwiperCarousel.init();
      });
      // Marker events
      marker.addListener("click", function () {
        infoWindows.forEach((win) => win.close());
        infoWindow.open(map, marker);
        setMarkersNormalIcon();

        const iconMarkerActive = generateMarkerIcon(1.4);
        marker.setIcon(iconMarkerActive);
        this.isActive = true;

        // eslint-disable-next-line no-undef
        dataLayer.push({
          event: "clickMarker",
          markerLabel: location.title,
        });
      });

      marker.addListener("mouseover", function () {
        const iconMarkerHover = generateMarkerIcon(1.4);
        if (!this.isActive) {
          marker.setIcon(iconMarkerHover);
        }
      });

      marker.addListener("mouseout", function () {
        const iconMarkerNoHover = generateMarkerIcon(1);
        if (!this.isActive) {
          marker.setIcon(iconMarkerNoHover);
        }
      });
      map.fitBounds(bounds);
    });
    map.addListener("idle", restrictBoundaries);
  } else {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: "USA" }, function (results, status) {
      if (status === google.maps.GeocoderStatus.OK) {
        if (!window.marketLocations) {
          map.setZoom(8);
          map.setCenter(results[0].geometry.location);
          map.fitBounds(results[0].geometry.viewport);
        }
      }
    });
  }

  // Map events
  map.addListener("click", function () {
    infoWindows.forEach((win) => win.close());
    setMarkersNormalIcon();
    map.fitBounds(bounds);
  });

  map.addListener("tilesloaded", () => {
    var images = document.querySelectorAll(".js-market-new-map img");
    images.forEach(function (image) {
      image.alt = "Google Maps Image";
    });
  });
}

function handleMobileMap() {
  const showMapEl = $(".show-map");
  const mapEl = $(".js-show-mobile-map");
  showMapEl.click(function () {
    if ($(window).width() < 1024) {
      if (!mapEl.hasClass("show-full-mobile")) {
        mapEl.addClass("show-full-mobile");
        $("body").addClass("map-open");
      }
    }
    map.fitBounds(bounds);
  });
}

function eventCloseMap() {
  $("#closeMap").click(() => {
    const mapEl = $(".js-show-mobile-map");
    mapEl.removeClass("show-full-mobile");
    $("body").removeClass("map-open");
  });
}

function restrictBoundaries() {
  let isAnyMarkerVisible = false;
  let mapCenter = map.getCenter();
  let x = mapCenter.lng();
  let y = mapCenter.lat();

  map.markers.forEach((marker) => {
    const isOnTheMap = map.getBounds().contains(marker.getPosition());
    if (isOnTheMap) {
      isAnyMarkerVisible = true;
    }
  });

  if (!isAnyMarkerVisible) {
    let maxX = centerMapBounds.getNorthEast().lng();
    let maxY = centerMapBounds.getNorthEast().lat();
    let minX = centerMapBounds.getSouthWest().lng();
    let minY = centerMapBounds.getSouthWest().lat();

    if (x < minX) x = minX;
    if (x > maxX) x = maxX;
    if (y < minY) y = minY;
    if (y > maxY) y = maxY;

    map.setCenter(new google.maps.LatLng(y, x));
  }
}

function createZoomControls(controlDiv, map) {
  let controlUI = document.createElement("div");
  controlUI.style.backgroundColor = "#fff";
  controlUI.style.border = "2px solid #fff";
  controlUI.style.borderRadius = "3px";
  controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
  controlUI.style.cursor = "pointer";
  controlUI.style.marginTop = "20px";
  controlUI.style.marginLeft = "20px";
  controlUI.style.width = "40px";
  controlUI.style.textAlign = "center";
  controlDiv.appendChild(controlUI);

  //Plus
  let controlPlusWrap = document.createElement("div");
  controlPlusWrap.style.width = "100%";
  controlPlusWrap.title = "Click to zoom up the map";
  controlPlusWrap.style.height = "40px";
  controlPlusWrap.style.display = "flex";
  controlPlusWrap.style.alignItems = "center";
  controlPlusWrap.style.justifyContent = "center";

  let controlPlus = document.createElement("img");
  controlPlus.src =
    "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU2ICg4MTU4OCkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+R3JvdXAgMjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJNYXJrZXQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJNYXJrZXQtLS1Nb2JpbGUtLS1NYXAtVmlldy0tLVBvcC1VcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMyLjAwMDAwMCwgLTE1My4wMDAwMDApIiBmaWxsPSIjMDEzRTNGIj4KICAgICAgICAgICAgPGcgaWQ9Ilpvb20tQ29udHJvbCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAuMDAwMDAwLCAxNDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIuMDAwMDAwLCAxMy4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSI3IiB5PSIwIiB3aWR0aD0iMiIgaGVpZ2h0PSIxNiI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguMDAwMDAwLCA4LjAwMDAwMCkgcm90YXRlKDkwLjAwMDAwMCkgdHJhbnNsYXRlKC04LjAwMDAwMCwgLTguMDAwMDAwKSAiIHg9IjciIHk9IjAiIHdpZHRoPSIyIiBoZWlnaHQ9IjE2Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
  controlPlus.alt = "Zoom Up";
  controlPlusWrap.appendChild(controlPlus);

  controlUI.appendChild(controlPlusWrap);

  controlPlusWrap.addEventListener("click", function () {
    const zoom = map.getZoom();
    map.setZoom(zoom + 1);
  });

  //Line
  let line = document.createElement("div");
  line.style.color = "rgb(25,25,25)";
  line.style.width = "30px";
  line.style.height = "1px";
  line.style.backgroundColor = "rgb(230, 230, 230)";
  line.style.marginLeft = "auto";
  line.style.marginRight = "auto";
  controlUI.appendChild(line);

  //Minus
  let controlMinusWrap = document.createElement("div");
  controlMinusWrap.style.width = "100%";
  controlMinusWrap.title = "Click to zoom down the map";
  controlMinusWrap.style.height = "40px";
  controlMinusWrap.style.display = "flex";
  controlMinusWrap.style.alignItems = "center";
  controlMinusWrap.style.justifyContent = "center";

  let controlMinus = document.createElement("img");
  controlMinus.src =
    "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIycHgiIHZpZXdCb3g9IjAgMCAxNiAyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1NiAoODE1ODgpIC0gaHR0cHM6Ly9za2V0Y2guY29tIC0tPgogICAgPHRpdGxlPkdyb3VwIDI8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iTWFya2V0IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTWFya2V0LS0tTW9iaWxlLS0tTWFwLVZpZXctLS1Qb3AtVXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMi4wMDAwMDAsIC0xOTkuMDAwMDAwKSIgZmlsbD0iIzAxM0UzRiI+CiAgICAgICAgICAgIDxnIGlkPSJab29tLUNvbnRyb2wiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwLjAwMDAwMCwgMTQwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjAwMDAwMCwgNTkuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC4wMDAwMDAsIDEuMDAwMDAwKSByb3RhdGUoOTAuMDAwMDAwKSB0cmFuc2xhdGUoLTguMDAwMDAwLCAtMS4wMDAwMDApICIgeD0iNyIgeT0iLTciIHdpZHRoPSIyIiBoZWlnaHQ9IjE2Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
  controlMinus.alt = "Zoom Down";
  controlMinusWrap.appendChild(controlMinus);

  controlUI.appendChild(controlMinusWrap);

  controlMinusWrap.addEventListener("click", function () {
    const zoom = map.getZoom();
    map.setZoom(zoom - 1);
  });
}

function setMarkersNormalIcon() {
  const normalIcon = generateMarkerIcon(1);
  for (var j = 0; j < map.markers.length; j++) {
    map.markers[j].setIcon(normalIcon);
    map.markers[j].isActive = false;
  }
}

function generateMarkerIcon(scale) {
  return {
    path:
      "m 123.0503,640.76516 c 2.31198,2.33425 3.70486,5.42807 3.92193,8.71122 0.11879,1.79866 -0.1444,3.60211 -0.77216,5.29115 -0.6116,1.67937 -1.60546,3.26671 -2.95864,4.70836 l -8.68481,9.27868 c -0.14238,0.15823 -0.3456,0.24758 -0.55809,0.24543 -0.21176,-10e-4 -0.41364,-0.0901 -0.55809,-0.24543 l -8.68481,-9.27868 c -1.35318,-1.44165 -2.34704,-3.02899 -2.95864,-4.70836 -0.62038,-1.69093 -0.88334,-3.49281 -0.77216,-5.29115 0.21552,-3.28354 1.60864,-6.37788 3.92193,-8.71122 2.39931,-2.41058 5.65584,-3.76516 9.05177,-3.76516 3.39593,0 6.65247,1.35458 9.05177,3.76516 z M 114,646 c -2.20513,0 -4,1.79449 -4,4 0,2.20551 1.79487,4 4,4 2.20513,0 4,-1.79449 4,-4 0,-2.20551 -1.79487,-4 -4,-4 z",
    strokeWeight: 0,
    fillColor: "#084c4f",
    fillOpacity: 1,
    rotation: 0,
    scale: scale,
    anchor: {
      x: 114,
      y: 665,
    },
  };
}

function hoverPin() {
  $(".location-marker-til").hover(
    function () {
      const marketLocationId = parseInt($(this).data("marker-id"));
      const iconMarkerHover = generateMarkerIcon(1.4);

      const markerToChange = map.markers.filter(
        (marker) => marker.markerId === marketLocationId
      )[0];
      if (!markerToChange.isActive) {
        markerToChange.setIcon(iconMarkerHover);
      }
      $(this).find('[data-toggle="tooltip"]').tooltip("show");
    },
    function () {
      const marketLocationId = parseInt($(this).data("marker-id"));
      const iconMarker = generateMarkerIcon(1);

      const markerToChange = map.markers.filter(
        (marker) => marker.markerId === marketLocationId
      )[0];
      if (!markerToChange.isActive) {
        markerToChange.setIcon(iconMarker);
      }

      $(this).find('[data-toggle="tooltip"]').tooltip("hide");
    }
  );
}

export default initMarketMap;
